/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Forgot_PasswordInputs */

const en_auth_login_forgot_password = /** @type {(inputs: Auth_Login_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot your password?`)
};

const pl_auth_login_forgot_password = /** @type {(inputs: Auth_Login_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie pamiętasz hasła?`)
};

/**
* | output |
* | --- |
* | "Forgot your password?" |
*
* @param {Auth_Login_Forgot_PasswordInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_forgot_password = /** @type {((inputs?: Auth_Login_Forgot_PasswordInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Forgot_PasswordInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_forgot_password(inputs)
	return en_auth_login_forgot_password(inputs)
});